'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { ComingSoonPolicyCard, PolicySectionHeader } from '@/features/identity-policy';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/idp/_layout/settings/authentication-method/')({
  component: IdpAuthenticationMethodPage
});
function IdpAuthenticationMethodPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.idp.settings.authenticationMethod'
  });
  return <VStack className="w-full gap-4">
      <PolicySectionHeader iconName="KeyRoundIcon" title={t('title')} description={t('description')} />
      <ComingSoonPolicyCard />
    </VStack>;
}